import { money } from "@/lib/money";

export const CostBreakdown = ({ quote, compact = false }) => {
  if (!quote) return null;
  const fmt = (n) => money(n, quote.moneda || "CLP");
  const usaAvaluo = quote.impuesto_base_fuente === "avaluo";
  const refValor = quote.impuesto_sobre_valor_referencial;
  const refAvaluo = quote.impuesto_sobre_avaluo;
  return (
    <div data-testid="cost-breakdown">
      <div className="space-y-1.5">
        {quote.items.map((it) => (
          <div key={it.key} className="flex items-start justify-between gap-2 text-[11px]">
            <span className="text-slate-600 leading-tight">{it.label}</span>
            <span className="font-semibold text-[#1F2937] font-mono-tf whitespace-nowrap">{fmt(it.amount)}</span>
          </div>
        ))}
      </div>

      {/* Comparativo 1,5% sobre avalúo vs valor de venta — siempre compacto en el simulador */}
      {refValor != null && (
        <div className="mt-2.5 rounded bg-slate-50 border border-slate-200 px-2.5 py-2 text-[10px]" data-testid="impuesto-comparativo">
          <p className="font-semibold text-[#13315C] mb-1">Comparativo 1,5%</p>
          <div className="flex justify-between leading-tight">
            <span className="text-slate-600">Sobre avalúo (oficial)</span>
            <span className={`font-mono-tf ${usaAvaluo ? "font-bold text-emerald-700" : "text-slate-400 italic"}`}>
              {usaAvaluo ? fmt(refAvaluo) : "—"}
            </span>
          </div>
          <div className="flex justify-between leading-tight">
            <span className="text-slate-600">Sobre precio (referencial)</span>
            <span className={`font-mono-tf ${usaAvaluo ? "text-slate-400" : "font-bold text-amber-700"}`}>{fmt(refValor)}</span>
          </div>
          {!usaAvaluo && !compact && (
            <p className="mt-1.5 text-[9px] text-amber-700 leading-tight">
              ⚠️ Sin avalúo usamos el precio como referencia. El cobro real suele ser menor — completa el avalúo para verlo.
            </p>
          )}
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-slate-200 flex items-center justify-between">
        <span className="font-display font-bold text-[#13315C] text-sm">Total estimado</span>
        <span className="font-display font-extrabold text-[#13315C] text-xl" data-testid="cost-total">
          {fmt(quote.total)}
        </span>
      </div>
      {!compact && (
        <p className="mt-2 text-[10px] text-slate-400 leading-tight">{quote.disclaimer}</p>
      )}
    </div>
  );
};
